module.exports = __webpack_public_path__ + "static/img/5.67b0fa6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/yayaLand/version/03/5.png
// module id = KHgE
// module chunks = 1